import React from "react";
import CloseModal from "../../mui/close_modal/CloseModal";
import { useTranslation } from "react-i18next";
import imgLock from "./banner-lock.webp";
import "./show-new-pas.scss";
import CusInput from "../../mui/custom_input/CusInput";
import CusButton from "../../mui/custom_button/CusButton";

export default function ShowNewPasContent({ closeModal, shownNewPas }) {
  const { t } = useTranslation();

  return (
    <div className="show-new-pas">
      <CloseModal close={closeModal} />
      <div className="show-new-pas__img">
        <img src={imgLock} height={120} />
      </div>
      <div className="show-new-pas__fields">
        <h2>{t("New password set")}</h2>
        <div className="show-new-pas__fields__forms">
          <CusInput readOnly isCopy defaultValue={shownNewPas} />

          <CusButton className="remind-submit" text={"Copy"} color="gradient-blue" />
        </div>
      </div>
    </div>
  );
}
